
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'
import TenantUserCreateDetailsTab from '@/views/tenantUser/tabs/create/TenantUserCreateDetailsTab.vue'
import ls from '@/ls'

@Component({
  components: { TenantUserCreateDetailsTab }
})

export default class TenantUserCreate extends Vue {
  settings = {
    routeNames: { list: 'tenantUsers', show: 'tenantUserShow', edit: 'tenantUserEdit' },
    routeParamKey: 'tenantUserId',
    permissionNames: { show: 'tenants.users.view', edit: 'tenants.users.edit', delete: 'tenants.users.delete' },
    functionNames: { setCurrent: 'setCurrentTenantUser', clearCurrent: 'clearCurrentTenantUser', save: 'saveTenantUser' },
    getterNames: { current: 'currentTenantUser', loading: 'loadingTenantUser' }
  }

  currentTab:string = ls.get('tenantUserEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('tenantUserEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { [this.settings.routeParamKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
